var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import styled from 'styled-components';
import getThemeBreakpoints from '../../utils/getThemeBreakpoints';
import { Typographies } from '../../utils/getThemeTypography';
import Typography from '../Typography';
import { SharedPropsContext } from '.';
import { FontWeights } from '../../theme/typography';
var ModalHeader = function (_a) {
    var name = _a.name, title = _a.title, subTitle = _a.subTitle, className = _a.className, htmlProps = __rest(_a, ["name", "title", "subTitle", "className"]);
    var _b = useContext(SharedPropsContext), staticSize = _b.staticSize, parentName = _b.name, themeFamily = _b.themeFamily;
    return (_jsxs(Container, __assign({}, htmlProps, { staticSize: staticSize, className: className }, { children: [!!title && (_jsx(Title, __assign({ type: Typographies.H5_HEADING, themeFamily: themeFamily, "data-testid": (name || parentName) + "-modal-title" }, { children: title }), void 0)),
            !!subTitle && (_jsx(SubTitle, __assign({ type: Typographies.BODY2, themeFamily: themeFamily, "data-testid": (name || parentName) + "-modal-subtitle" }, { children: subTitle }), void 0))] }), void 0));
};
export default ModalHeader;
var Title = styled(Typography)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  margin: 0 0 8px;\n  font-weight: ", ";\n"], ["\n  color: ", ";\n  margin: 0 0 8px;\n  font-weight: ", ";\n"])), function (_a) {
    var theme = _a.theme, themeFamily = _a.themeFamily;
    return theme.families.modal[themeFamily].dark;
}, FontWeights.MEDIUM);
var SubTitle = styled(Typography)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: ", ";\n  margin: 0;\n"], ["\n  color: ", ";\n  margin: 0;\n"])), function (_a) {
    var theme = _a.theme, themeFamily = _a.themeFamily;
    return theme.families.modal[themeFamily].text;
});
var Container = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), getThemeBreakpoints('modalContent'));
var templateObject_1, templateObject_2, templateObject_3;
